const K = {
  Network: {
    URL: {
      // Development
      Base: process.env.REACT_APP_BASE_URL,
      BaseAPI: process.env.REACT_APP_BASE_API_URL,
      DomainName: process.env.REACT_APP_CLIENT_DOMAIN_NAME,
      Timeout: process.env.REACT_APP_TIMEOUT,
      Protocol: process.env.REACT_APP_PROTOCOL,
      Client: {
        BaseHost: process.env.REACT_APP_CLIENT_BASE_HOST,
        BasePort: process.env.REACT_APP_CLIENT_BASE_PORT,
      },

      // User Authentication
      LoginUser: "Auth/login",
      RegisterUser: "Auth/signup",
      LoginWithGoogle: "Auth/continueWithGoogle",
      GetUserDetails: "Auth/getUserDetails",
      GetUserRoles: "Auth/getAllRoles",

      // Forget password
      ForgotPassword: "Auth/passwordresetLink",

      //Create Diary
      CreateDiary: "Diarist/createDiary",
      //Reset password

      //Get Relationships
      GetAllRelationship: "DataEntry/getAllRelationship",
      GetRelationshipTypes: "Diarist/getAllRelationshipTypes",

      //Add Type
      AddType: "DataEntry/addType",

      ResetPassword: "Auth/resetPassword",

      GetAllTopics: "DataEntry/getAllTopic",

      //Verify User
      VerifyUser: "Auth/checkEmailVerification",
      ResendVerificationEmail: "Auth/resendVerificationEmail",

      //dairies topics
      GetDiaryTopics: "Diarist/getDiaryTopics",
      AddGlobalTopicToDiary: "Diarist/addDiaryTopic",

      //entries
      AddEntry: "Diarist/addEntry",
      GetAllDraftedEntries: "Diarist/getAllDraftEntries",
      DeleteEntry: "Diarist/deleteEntry",
      ReleaseAllEntries: "Diarist/releaseAllEntries",
      ReviseEntry: "Diarist/reviseEntry",

      //Get all Diaries
      GetAllDiaries: "Diarist/getAllDiaries",

      //Update Diary Invite
      UpdateInvite: "Diarist/updateDiaryInvite",

      GetAllEntries: "Diarist/getAllDiaryEntries",

      GetDiary: "Diarist/getDiary",

      UpdatePassword: "Auth/updatePassword",
      UpdateUserDetails: "Auth/updateUserDetails",

      LockUnlockDiary: "Diarist/lockunlockdiary",

      //upload profile image
      UploadProfileImage: "Auth/uploadProfileImage",

      //get profile image
      GetProfileImage: "Auth/getProfileImage",

      //remove profile
      RemoveProfileImage: "Auth/deleteProfileImage",

      //Diary Contains Drafted Entries
      DraftedEntriesStatus: "Diarist/diaryContainDraftedEntries",
      // notify diarist about Lock
      NotifyDiaristAboutLock: "Diarist/notifyDiaristToUnLock",

      //Update user status
      UpdateUserStatus: "Auth/updateUserStatus",

      //Get Notifications
      GetNotification: "Auth/getNotifications",
      // Reminder Email
      ReminderEmail: "Diarist/sendReminderEmailToRequestedCoDiarist",
      //read unread messages count
      MarkAsRead: "Auth/markAsRead",

      //Reset Count Notification
      ResetCount: "Auth/resetTotalNotificationCount",

      //feedback api

      sendFeedback: "Diarist/sendFeedback",

      // Search
      GlobalSearch: "Diarist/getAcrossDiarySearchResults",

      // Personality
      PersonalityTypes: "Diarist/getAllPersonalityProfileTypes",
      UpdatePersonalityType: "Auth/updateUserPersonalityProfileType",

      // Declined Diary Invite
      DeclindOrBlockedDiaryInvite: "Diarist/declineOrBlockDiaryInvite",

      // Get Global Settings
      GetGlobalSettings: "Admin/getGlobalSettings",

      // Resend Journal Invite
      ResendJournalInvite: "Diarist/resendJournalInvite",

      // Stripes
      CreateCheckoutSession: "Stripe/createCheckoutSession",
      ModifySubSession: "Stripe/createModifySubscriptionSession",
      CancelSubscription: "Stripe/cancelUserSubscription",

      // Archive/Unarchive
      ArchiveUnarchiveJournal: "Diarist/requestArchiveOrUnarchiveADiary",
    },
    Method: {
      GET: "GET",
      PUT: "PUT",
      POST: "POST",
      PATCH: "PATCH",
      DELETE: "DELETE",
    },
    Header: {
      ContentType: "Content-Type",
      ApplicationJson: "application/json",
      Default: (token = "") => ({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      }),
      Authorization: (token = "") => ({
        Authorization: "Bearer " + token,
      }),
      Type: {
        Json: "json",
        File: "multipart/form-data",
      },
    },
    StatusCode: {
      Unauthorized: 401,
    },
  },
  Actions: {
    // General part of action
    CREATE: "CREATE",
    UPSERT: "UPSERT",
    DELETE: "DELETE",
    DELETE_ALL: "DELETE_ALL",
    SET: "SET",
  },
  Cookie: {
    Key: {
      User: "user",
      EncryptionKey: "logged_in_user",
    },
  },
  Roles: {
    Admin: "Admin",
    User: "User",
  },
};
export default K;
